import React, {Component} from "react";

class Error extends Component {
    render() {
        return (
            <div className="error">
                404
            </div>
        )
    }
}

export default Error;
